<div class="row card">
  <div class="card-header heading pad-horizontal-20">
    <span class="icon-complete-circle margin-right-10"></span>
    <span> {{ sectionHeader }}</span>
  </div>

  <div class="pad-10 padding-header-discounts">
    @for (discount of discountList; track discount) {
      <div class="row pad-horizontal-10 sm-pad-horizontal-50 pad-vertical-10 sm-pad-vertical-15">
        <div class="column nine pad-left-40 pad-right-20">
          <h4 class="coverage-heading">{{ discount }}</h4>
        </div>
        <div class="column three pad-left-20 md-pad-left-40 pad-right-20">
          <p><span class="icon-complete"></span></p>
        </div>
      </div>
    }
  </div>
</div>
